<template>
  <div class="protectedWildPlants">
    <breadcrumb class="bread" :path="path" :name="name" :childPath="childPath" :childName="childName"
                :childPathThree="childPathThree" :childNameThree="childNameThree"></breadcrumb>
    <div class="main-row contain">
     <div class="contain-top">
       <h3 class="contain-title">高黎贡山-伯舒拉岭重点保护野生植物名录</h3>
       <div class="contain-subTitle">截止2023年02月23日，物种数量为：101种（含变种），名录标准参考《国家重点保护野生植物名录》（ 2021）、《中国生物物种名录（ 2022版）》和《云南省极小种群野生植物保护名录（2021版）》
       </div>
     </div>
      <div class="col col-xlg-12 col-sm-12 protectedWildPlants-item">
    <ul  v-for="(item,index) in tableData" :key="index"  class="parent">
      <div class="title">{{item.sectionChinese}}&nbsp;{{item.sectionLatin}}</div>
<!--      种中文名+空格+种拉丁名-简+空格+命名人+空格+（备注）【备注的字体比前面的小一号】-->
      <li class="child" v-for="(child, i) in item.bershuraMountainsList" :key="i">
<!--        {{child}} -{{child.growLatin}}&nbsp;-->
        <span class="main">{{child.growChinese}}&nbsp;
          <span class="simple">{{child.growLatinSimple}}&nbsp;</span>
          {{child.namer}}&nbsp;
        </span>
        <span class="note">{{child.note}}</span>
      </li>
    </ul>
        <el-pagination class="pagin"
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :current-page.sync="pageIndex"
                       :page-size="pageSize"
                       layout="total, prev, pager, next"
                       :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 高黎贡山-伯舒拉岭重点保护野生植物名录
 */
import breadcrumb from '@/components/breadcrumb'
import {getBershuraMountainsBc} from "@/network/gaoligongdirectory/bershuramountains";
export default {
  name: "protectedWildPlants",
  components: {breadcrumb },
  data() {
    return {
      path: '',
      name: '',
      childName:'',
      childPath:'',
      childPathThree: '',
      childNameThree: '',
      pageIndex: 1,
      pageSize: 10,
      tableData: [],
      total: 0
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.path = from.path
      vm.name = '资源'

    })
  },
  created() {
    this.childPathThree=this.$route.path
    this.childNameThree = this.$route.name
    this.childName = '名录'
    this.childPath = this.$route.path
  },
  mounted() {
    this.getList()
  },
  methods: {
    getList() {
      getBershuraMountainsBc(Object.assign({
        page: this.pageIndex,
        pageSize: this.pageSize,
        // type: this.type
      })).then(res => {
        // console.log('124545',res)
        this.tableData = res.data.data.sectionChineseList
        this.total = res.data.data.total
      })
    },
    handleSizeChange(val){
      this.pageSize = val
      this.pageIndex = 1
      this.getList()

    },
    handleCurrentChange(val){
      this.pageIndex = val
      this.getList()
    },
  }
}
</script>

<style scoped lang="scss">
@import "../../../assets/css/protectedWildPlants";
::v-deep .el-pagination {
  padding: 20px 5px !important;
  text-align: center;
}
</style>